var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Contact"},[_c('Hero',{staticClass:"lift"},[_c('h1',[_vm._v(_vm._s(_vm.$t('title')))])]),_c('SectionOffices')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }